/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { Button, Card, CardContent, } from "@mui/material";
import Grid from "@mui/material/Grid";
// import { GridSearchIcon } from "@mui/x-data-grid";
// import { loadingAction } from "ReduxReducers/loadingReducer";
// import axios from "axios";
import { BTable } from "components/BTable/BTable";
import { getColorMappings } from "components/ColorComponent/ColorComponent";
// import TimelineItem from "components/Icon/TimelineItem";
import LoadingModal from "components/LoadingModel/loadingModal";
// import MDButton from "components/MDButton";
// import BillingModal from "components/displayModel/billingModel";
// import InvoiceModal from "components/invoiceModal/invoiceModal";
import { useMaterialUIController } from "context";
// import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
// import DashboardNavbar from "examples/Navbars/DashboardNavbar";
// import PageTitle from "examples/PageTitle/PageTitle";
import { useCallback, useEffect, useState } from "react";
import DataTable, { createTheme } from "react-data-table-component";
import { useDispatch, } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import 'react-toastify/dist/ReactToastify.css';
import { getScreenRight, showResMsg } from "utils/generic";
import { genericMessage } from "utils/genericMessages";
import { fetchActivityLog } from "utils/api";
import BasicModal from "components/displayModel/activityNotesModal";
import { validateField } from "utils/generic";
// import { set } from "date-fns";
import { saveNotes } from "utils/api";
// import { setLayout } from "context";
import Typography from '@mui/material/Typography';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropDown from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
// import ArchiveIcon from '@mui/icons-material/Archive';

const SCREEN_NAME = "Invoices";
let SCREEN_RIGHT;

createTheme(
  'solarized',
  {
    text: {
      primary: 'white',
      secondary: 'white',
    },
    background: {
      default: '#202940',
    },
    context: {
      background: '#202940',
      text: 'white',
    },
    divider: {
      default: 'white',
    },
    sortFocus: {
      default: '#2aa198',
    },
  },
  'dark',
);
const errMsg = {
  color: `red`,
  fontSize: `11px`,
};
createTheme(
  'light',
  {
    text: {
      primary: 'black',
      secondary: 'black',
    },
    background: {
      default: 'white',
    },
    context: {
      background: 'white',
      text: 'black',
    },
    divider: {
      default: 'gray',
    },
    //   button: {
    //     default: '#2aa198',
    //    hover: 'rgba(0,0,0,.08)',
    //    focus: 'rgba(255,255,255,.12)',
    //  disabled: 'rgba(255, 255, 255, .34)',
    // },
    sortFocus: {
      default: '#2aa198',
    },
  },
  'dark',
);

function ActivityLog(props) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const id = useParams();
  const [rows, setRows] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [showModal, setshowModal] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [perPage, setPerPage] = useState(10);
  const [toggleCleared, setToggleCleared] = useState(false);
  const [title, setTitle] = useState("");
  const [controller] = useMaterialUIController();
  const { darkMode, sidenavColor } = controller;
  const { barColor, tableBorder } = getColorMappings(sidenavColor);

  const dispatch = useDispatch();
  const [loginDetails, setLoginDetails] = useState(JSON.parse(sessionStorage.getItem("LOGIN_DETAILS")));

  const [values, setValues] = useState({
    _id: id.id,
    businessUserID: loginDetails?.businessUserID,
    userID: loginDetails?._id,
    details: "",
    sortingType: "",
    screenType: props.name,
    sortingField: "",
    invoiceStatus: "All",
    page: 1,
    limit: 10,
    filterValues: "",
    searchParameterList: ['dateAndTime', 'name', 'action', 'details'],
  });
  const [screenAccess, setScreenAccess] = useState(false);
  const [detailsErr, setDetailsErr] = useState();
  const [expanded, setExpanded] = useState(false);



  useEffect(() => {
    fetchActivity();
  }, []);

  const toggleExpand = () => {
    setExpanded(!expanded);
  };

  async function getRight() {
    SCREEN_RIGHT = await getScreenRight(SCREEN_NAME);
    setScreenAccess(SCREEN_RIGHT === 'Full Access' ? true : false);
  }

  const fetchActivity = async () => {
    values.token = loginDetails.token;
    values.perPage = perPage;
    fetchActivityLog(values, (data) => {
      setRows(data.Result_Output.docs);
      setTotalRows(data.Result_Output.totalDocs);
    }, dispatch)
  }

  const handleChange = (name) => (event) => {
    setValues({ ...values, [name]: event.target.value });

  };



  const handleSave = () => {
    let mandateFlag = false;
    mandateFlag = validateField(values.details, setDetailsErr) || mandateFlag;
    if (mandateFlag) {
      return;
    }
    saveNotes(values, (data) => {
      setshowModal(false)
      if (data.Result_Status) {
        setExpanded(true);
        fetchActivity();
        showResMsg(genericMessage.added, 1000, data.Result_Status);
        setValues({ ...values, details: "" });
      } else {
        showResMsg(data.Result_Message, 2000, data.Result_Status);
      }
    }, dispatch);

  }

  const handleSearchFilter = (event) => {
    setValues({ ...values, filterValues: event.target.value });
  };

  // const handleSort = async (column, sortDirection) => {

  //   values.sortingField = column;
  //   values.sortingType = sortDirection;
  //   await fetchActivity();
  // };
  const handleSort = async (column, sortDirection) => {

    if (sortDirection === "asc") {
      values.sortingType = 1;
    }
    else {
      values.sortingType = -1;
    }
    values.sortingField = column.sortField;
    await fetchActivity();
  };

  const handlePageChange = page => {
    values.page = page;
    fetchActivity();
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    setLoading(true);
    values.page = page;
    values.limit = newPerPage;
    setPerPage(newPerPage);
    setLoading(false);
    fetchActivity();
  };

  const handleRowSelected = useCallback(state => {
    setSelectedRows(state.selectedRows);
    if (state.selectedRows.length > 0) {
      setTitle(" ");
    }
    else {
      setTitle("");
    }
  }, []);

  const customStyles = {
    table: {
      style: {
        borderColor: tableBorder,
      },
    },
    headRow: {
      style: {
        color: darkMode ? "white" : "white",
        background: barColor,
      },
    },
    headCells: {
      style: {
        paddingRight: '0px',
        fontWeight: 'bold',
        fontSize: '14px',
        color: "white",
      },
    },
  };


  let columns = [
    {
      name: <p style={{ paddingLeft: "12px", fontSize: "12px" }}>Date/Time</p>,
      selector: row => (
        <span style={{ fontSize: "12px" }}>{row.dateAndTime}</span>
      ),
      sortable: true,
      sortField: 'dateAndTime',

    },
    {
      name: <p style={{ paddingLeft: "12px", fontSize: "12px" }}>User</p>,
      selector: row => (
        <span style={{ fontSize: "12px" }}>{row.name}</span>
      ),
      sortable: true,
      sortField: 'name',
      center: "true",

    },
    {
      name: <p style={{ paddingLeft: "12px", fontSize: "12px" }}>Action</p>,
      selector: row => (
        <span style={{ fontSize: "12px" }}>{row.action}</span>
      ),
      sortable: true,
      sortField: 'action',
      center: 'true',
    },
    {

      name: <p style={{ paddingLeft: "25px", fontSize: "12px" }}>Details</p>,
      selector: row => (
        <span style={{ fontSize: "12px" }}>{row.details}</span>
      ),
      sortable: true,
      sortField: 'details',
      center: 'true',
    },
  ];
  const addNotes = () => {
    setshowModal(!showModal);
  }

  return (
    <div>
      <div style={{ marginTop: '10px' }}>
        <div>
          <div px={2} style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <Button onClick={toggleExpand}>
              <Typography variant="h6" sx={{ border: "1px solid #1ed6c9", borderRadius: "5px", color: "#1ed6c9", display: 'flex', alignItems: 'center', marginLeft: "-9px", padding: "1px 10px", fontSize: "12px" }}>
                History And Notes
                {expanded ? <ArrowDropDown className="arrowdropdown" style={{ marginLeft: "5px", }} /> : <ArrowDropUpIcon className="arrowdropdown" style={{ marginLeft: "5px", }} />}
              </Typography>
            </Button>
            <Button>
              <Typography variant="h6" sx={{ border: "1px solid #1ed6c9", borderRadius: "5px", color: "#1ed6c9", display: 'flex', alignItems: 'center', marginLeft: "-9px", padding: "3.75px 10px", fontSize: "12px" }}
                onClick={addNotes}
              >
                Add Note
              </Typography>
            </Button>
          </div>

          {expanded && (
            <Card color="primary">
              <Grid container display={"flex"} justifyContent="end" mt={1.6} gap={2} >
              </Grid>
              <CardContent style={{ marginTop: "-12px" }}>

                <DataTable
                  theme={darkMode ? 'solarized' : 'light'}
                  title={title}
                  columns={columns}
                  data={rows}
                  onSort={handleSort}
                  sortServer
                  pagination
                  paginationServer
                  paginationTotalRows={totalRows}
                  onChangeRowsPerPage={handlePerRowsChange}
                  onChangePage={handlePageChange}
                  customStyles={customStyles}
                  onSelectedRowsChange={handleRowSelected}
                  clearSelectedRows={toggleCleared}
                  fixedHeaderScrollHeight="410px"
                  fixedHeader={true}
                  paginationPerPage={10}

                  paginationComponentOptions={{ rowsPerPageText: 'Records Per Page' }}

                />
              </CardContent>
            </Card>
          )}



        </div>

        <LoadingModal loading={loading} />
        {showModal && <BasicModal
          open={showModal}
          handleClose={() => { setshowModal(false); setValues({ ...values, details: "" }); }}
          value={values.details}
          onChange={handleChange("details")}
          handleSave={handleSave}
          errText={detailsErr ? <span style={errMsg}>Notes can't be blank</span> : ""}
        />}
      </div>
    </div>

  );

}

export default ActivityLog;
